/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminSignInDto } from '../../models/admin-sign-in-dto';

export interface AdminControllerSignIn$Params {
      body: AdminSignInDto
}

export function adminControllerSignIn(http: HttpClient, rootUrl: string, params: AdminControllerSignIn$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * 액세스 토큰
 */
'accessToken'?: string;

/**
 * 리프레시 토큰
 */
'refreshToken'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, adminControllerSignIn.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      
      /**
       * 액세스 토큰
       */
      'accessToken'?: string;
      
      /**
       * 리프레시 토큰
       */
      'refreshToken'?: string;
      }>;
    })
  );
}

adminControllerSignIn.PATH = '/api/admin/signin';
